.l1Li {
    &:nth-last-child(1 of [data-has-children]) {
        border-bottom: 1px solid var(--white-gray);
        padding-bottom: 16px;
        margin-bottom: 16px;
    }
}

.l1liHidden {
    display: none;
}

.l1NavLinkBase {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    display: flex;
    align-items: center;
    position: relative;
    height: calc(var(--main-nav-height) - 1px);
    font: var(--font-button);
    text-align: left;
}

.l1NavLink {
    composes: l1NavLinkBase;
    padding-inline: 16px;

    &:hover {
        color: var(--red);
    }

    &[aria-expanded="true"] {
        box-shadow: inset 0 -2px 0 0 var(--red);
    }
}

.l1NavLinkMobile {
    composes: l1NavLinkBase;
    width: 100%;
    padding-block: 16px;

    &.l1NavLinkActive {
        width: calc(100% + calc(var(--labui-container-margin) * 2));
        margin-left: calc(var(--labui-container-margin) * -1);
        border-bottom: 1px solid var(--white-gray);
        justify-content: center;
        margin-top: calc(var(--l1-padding-block) * -1);
    }
}

.caretRight {
    --width: var(--spacer-24);

    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: var(--width);
    height: var(--width);
    pointer-events: none;

    .l1NavLinkActive & {
        left: var(--labui-container-margin);
        right: auto;
        transform: translateY(-50%) scaleX(-1);
    }
}
